module.exports = __webpack_public_path__ + "img/60.3.TP.27cdd74a.png";